import { Separator } from '@/components/ui/separator';
import { Skeleton } from '@/components/ui/skeleton';

/**
 * Full-card skeleton that mirrors the merged DayDetailPanel layout so the
 * right column of the month view doesn't visually jump while the day
 * overview is being fetched.
 */
export function DayDetailPanelSkeleton() {
  return (
    <div className="flex w-full flex-col overflow-hidden rounded-lg border bg-card shadow-sm">
      {/* Day summary (compact unified-summary footprint) */}
      <div className="flex flex-col gap-2.5 p-4">
        <Skeleton className="h-3 w-40" />
        <div className="flex items-baseline gap-2">
          <Skeleton className="h-6 w-20" />
          <Skeleton className="h-4 w-32" />
        </div>
        <Skeleton className="h-[14px] w-full rounded-full" />
        <div className="flex flex-wrap gap-x-4 gap-y-2 pt-1">
          <Skeleton className="h-4 w-24" />
          <Skeleton className="h-4 w-24" />
        </div>
      </div>

      <Separator />

      {/* Project breakdown */}
      <div className="flex flex-col gap-3 p-4">
        <Skeleton className="h-3 w-32" />
        {[0, 1].map(i => (
          <div key={i} className="flex flex-col gap-1.5 rounded-md border p-2.5">
            <div className="flex items-center gap-2">
              <Skeleton className="h-2 w-2 shrink-0 rounded-full" />
              <Skeleton className="h-4 w-32" />
              <div className="ml-auto flex items-center gap-2">
                <Skeleton className="h-4 w-10" />
                <Skeleton className="h-3 w-10" />
              </div>
            </div>
            <Skeleton className="h-1 w-full rounded-full" />
          </div>
        ))}
        <Separator />
        <div className="flex items-baseline justify-between">
          <Skeleton className="h-3 w-10" />
          <Skeleton className="h-4 w-40" />
        </div>
      </div>

      <Separator />

      <div className="flex flex-col gap-3 p-4">
        <Skeleton className="h-10 w-full rounded-md" />
        <Skeleton className="h-9 w-full rounded-md" />
      </div>
    </div>
  );
}
